import React from "react";
import { SnackbarProvider } from "notistack";
import { ThemeProvider } from "@mui/material/styles";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import CssBaseline from "@mui/material/CssBaseline";
import Embed from "player/components/Embed";
import PreviewEmbed from "player/components/PreviewEmbed";
import NoMatchScreen from "player/components/NoMatchScreen";
import initializeGa from "core/utils/initializeGa";
import { createTheme } from "core/utils/theme";
import CastProvider from "core/components/CastProvider";
import { ArenaQuery } from "core/queries";
import { useQuery } from "@apollo/client";
import LoadingScreen from "core/components/LoadingScreen";
import ArenaProvider from "core/components/ArenaProvider";

const anchorOrigin = {
  vertical: "top",
  horizontal: "center",
};

export default function App() {
  const { data, loading } = useQuery(ArenaQuery);

  if (loading) return <LoadingScreen />;

  const arena = data?.arena;

  initializeGa(arena);

  const theme = createTheme(arena?.theme);

  return (
    <ThemeProvider theme={theme}>
      <ArenaProvider value={arena}>
        <CssBaseline />
        <Helmet defaultTitle="Page not found" />
        <SnackbarProvider
          maxSnack={1}
          anchorOrigin={anchorOrigin}
          autoHideDuration={2000}
        >
          <CastProvider>
            <Routes>
              <Route path="/embed/preview/:token" element={<PreviewEmbed />} />
              <Route path="/embed/:contentId" element={<Embed />} />

              {/* todo: сделать редирект на бекенде */}
              <Route path="/embed/:platformId/:contentId" element={<Embed />} />
              <Route path="/:platformId/:contentId" element={<Embed />} />

              <Route path="*" element={<NoMatchScreen />} />
            </Routes>
          </CastProvider>
        </SnackbarProvider>
      </ArenaProvider>
    </ThemeProvider>
  );
}
